import remotesConfig from 'remotesConfig'
import taskmanagementcenteruiMfeConfig from 'taskmanagementcenteruiMfeConfig'
import injectWindowVariables from '@ve/module-federation/injectWindowVariables'
import injectScripts from '@ve/module-federation/injectScripts'
if (taskmanagementcenteruiMfeConfig?.maintenance?.enabled) {
  injectWindowVariables(remotesConfig)
  import('./bootstrap')
} else {
  injectWindowVariables(remotesConfig)
  injectScripts(remotesConfig)
  import('./bootstrap')
}
export {}
